/*
    Merrid Controls. Wszelkie prawa zastrzeżone.
    Plik zawiera kody Źródłowe będące własnością firmy Merrid Controls.
    Nie wolno ich rozpowszechniać w całości lub fragmentach bez wyraźnej zgody właściciela.
*/


import React from "react";


import {Col, Row} from "react-bootstrap";

import {AiFillDelete} from "react-icons/all";


import VEHICLE_INTERFACE from "@Services/Application/Interfaces/Vehicles/Vehicle";


type FavouriteVehiclesVehicleProps = {
    VEHICLE: VEHICLE_INTERFACE;
    REMOVE_FROM_FAVORITES_HANDLER(VEHICLE: VEHICLE_INTERFACE): void;

};


export const FavouriteVehiclesVehicleComponent: React.FC<FavouriteVehiclesVehicleProps> = ({
    VEHICLE,
    REMOVE_FROM_FAVORITES_HANDLER
}): JSX.Element | null => {


    const REMOVE_VEHICLE_FROM_FAVORITES = (): void => {
        REMOVE_FROM_FAVORITES_HANDLER(VEHICLE);
    };


    return (
        <Col xs={12} className={"vehicles-list-vehicle"}>
            <Row className={"vehicles-list-vehicle-content"}>

                <Col xs={10} className={"vehicle-information"}>
                    <span>{VEHICLE.TypeName}</span>
                    <span>{VEHICLE.RegNo}</span>
                </Col>

                <Col xs={2} className={"remove-from-favorites"}>
                    <span onClick={REMOVE_VEHICLE_FROM_FAVORITES}>
                        <AiFillDelete />
                    </span>
                </Col>

            </Row>
        </Col>
    );

};


export default FavouriteVehiclesVehicleComponent;
